import styled from 'styled-components';

export const ButtonList = styled.ul`
    display: flex;
    align-items: center;
    padding: calc(100vw * (11 / 375)) 0;
    width: 100%;
`;

export const ButtonItem = styled.li`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: calc(100vw * (10 / 375));

    &:first-of-type {
        margin: 0
    }
`;

export const HeartButton = styled.button`
    width: calc(100vw * (20.1 / 375));
    height: calc(100vw * (18.9 / 375));
`;

export const CommentButton = styled.button`
    width: calc(100vw * (17.9 / 375));
    height: calc(100vw * (17.9 / 375));
`;

export const CountNum = styled.span` 
    font-size: calc(100vw * (12 / 375));
    font-weight: 500;
    color: #7f7f7f;
    margin-left: calc(100vw * (3.5 / 375));
`;

export const AnimationBlock = styled.div`
    position: relative;
    width: calc(100vw * (20.1 / 375));
    height: calc(100vw * (18.9 / 375));
`;